<div></div>
@if (showBtnUplod) {
  <input type="file" (change)="fileChangeEvent($event)"/>
}
<br/>
<br/>

<div>
  <lib-image-cropper
    [imageChangedEvent]="imageChangedEvent"
    [imageBase64]="imageBase64"
    [maintainAspectRatio]="true"
    [containWithinAspectRatio]="containWithinAspectRatio"
    [aspectRatio]="4 / 4"
    [resizeToWidth]="256"
    [cropperMinWidth]="128"
    [onlyScaleDown]="true"
    [roundCropper]="false"
    [canvasRotation]="canvasRotation"
    [transform]="transform"
    [alignImage]="'left'"
    [style.display]="showCropper ? null : 'none'"
    format="png"
    (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded()"
    (cropperReady)="cropperReady($event)"
    (loadImageFailed)="loadImageFailed()"
  ></lib-image-cropper>
</div>

<div
  style="display: flex;flex-direction: row ;justify-content: center ;padding: 5px;flex-wrap: wrap"
  >
  <button class="btn-floating" (click)="rotateLeft()">
    <i class="material-icons"> rotate_left </i>
  </button>
  <button class="btn-floating" (click)="rotateRight()">
    <i class="material-icons"> rotate_right </i>
  </button>
  <button class="btn-floating" (click)="flipHorizontal()">
    <i class="material-icons"> flip </i>
  </button>
  <button class="btn-floating" (click)="flipVertical()">
    <i class="material-icons"
           style='transform: rotate(
      90deg
       );'

    > flip </i>
  </button>


  <button class="btn-floating" (click)="resetImage()">
    <i class="material-icons"> restart_alt </i>
  </button>
  <div>
    <button class="btn-floating" (click)="zoomOut()">
      <i class="material-icons"> zoom_out </i>
    </button>
    <button class="btn-floating" (click)="zoomIn()">
      <i class="material-icons"> zoom_in </i>
    </button>
  </div>
  <button class="btn" (click)="toggleContainWithinAspectRatio()">
    @if (!containWithinAspectRatio) {
      <span >{{ 'uploadImage.containWithinAsp' | translate}}</span>
    }
    @if (containWithinAspectRatio) {
      <span>{{'uploadImage.fillAsRatio' | translate}}</span>
    }

  </button>
</div>
<div style="background: #8080800a;padding: 10px">
  <div
        style="
margin: auto;
    width: 255px;

"
    >
    <img
      [src]="croppedImage"
      [style.border]="croppedImage ? '1px solid black' : 'none'"
      />
  </div>
</div>

